import {UserUpdatePayload} from 'app/models/user-profile-snapshot.model';
import { HttpResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { User } from '../../../models/user.model';
import { AdminService } from '../../../services/admin.service';
import { UserInfoBody } from '../../../services/admin.service.types';
import { GroupContext } from '../../../models/group-context.model';
import { UserService } from '../../../services/user.service';
import { OffboardingService } from '../../../services/offboarding.service';
import { OffboardingPermissions } from '../../../models/offboarding.model';
import {
  UserProfile,
  UserWrapper,
  ViewUserProfileLearningWeight
} from './view-user-profile.types';
import { PROFILE_ROUTE_USER_ID } from './view-user-profile.constants';
import { scrollViewUserProfileToTop } from './view-user-profile.platform';

@Injectable()
export class ViewUserProfileGateway {
  private route: ActivatedRoute;
  private offboarding: OffboardingService;
  constructor(
    private userService: UserService,
    private adminService: AdminService,
    injector: Injector
  ) {
    this.route = injector.get(ActivatedRoute);
    this.offboarding = injector.get(OffboardingService);
  }

  activeUser(): User {
    return this.userService.getLocal();
  }

  loadWorkflowPermissions(): Observable<OffboardingPermissions> {
    return this.offboarding.permissions();
  }

  routeUserId(): string {
    return this.route.snapshot.params[PROFILE_ROUTE_USER_ID];
  }

  getProfileFragment(): string {
    return this.route.snapshot.fragment;
  }

  resetScroll(): void {
    if (!this.route.snapshot.fragment) { scrollViewUserProfileToTop(); }
  }

  loadUser(userId: string): Observable<HttpResponse<UserProfile>> {
    return <Observable<HttpResponse<UserProfile>>><Object>this.userService.getUserFromAPI(userId);
  }

  loadEditableProfile(userId: string): Observable<UserUpdatePayload<UserProfile>> {
    return <Observable<UserUpdatePayload<UserProfile>>><Object>this.adminService.getUserProfileSnapshot(userId);
  }

  loadUserGroups(userId: string): Observable<HttpResponse<UserInfoBody>> {
    return <Observable<HttpResponse<UserInfoBody>>><Object>this.adminService.getUserInfo(userId);
  }

  loadGroupContext(groupId: string): Observable<HttpResponse<GroupContext>> {
    return this.adminService.getGroupContext(groupId);
  }

  updateUser(user: UserProfile, groups: Object[]): Observable<HttpResponse<UserProfile>> {
    const request: UserWrapper = {user, groupsWithPositions: groups};
    return this.adminService.updateUser(request);
  }

  updateOvertime(userId: string, enabled: boolean): Observable<HttpResponse<Object>> {
    return <Observable<HttpResponse<Object>>><Object>this.adminService.postiruemOver(userId, enabled);
  }

  loadLearningWeight(
    userId: string,
    ownProfile: boolean
  ): Observable<HttpResponse<ViewUserProfileLearningWeight>> {
    const request = ownProfile
      ? this.userService.getOwnLearningWeightSum()
      : this.userService.getUserLearningWeightSum(userId);
    return <Observable<HttpResponse<ViewUserProfileLearningWeight>>><Object>request;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-profile/view-user-profile.gateway.ts